const styles = {
    container: (theme, isMobile) => ({
        display: "flex",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        flexDirection: isMobile ? "column" : "row",
    }),

    sidePanel: {
        flex: 1,
        backgroundColor: "#f5f5f5",
    },

    formContainer: (isMobile) => ({
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
        width: isMobile ? "100%" : "auto",
    }),

    formWrapper: {
        width: "100%",
        maxWidth: 400,
        padding: 4,
    },

    headerContainer: {
        textAlign: "center",
        marginBottom: 4,
    },

    headerText: {
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        fontWeight: "bold",
        textTransform: "uppercase",
    },

    headerLine: {
        borderBottom: "2px solid #bbb",
        marginTop: 1,
    },

    formTitle: {
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        textAlign: "left",
        fontWeight: "normal",
        textTransform: "uppercase",
        marginBottom: 1,
    },

    submitButton: {
        width: "100%",
    },
};

export default styles;
